import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';

const HeaderFlyoutLocaleForm = ({ country }) => <form className="c-form   o-box">
    <div className="c-form__element">
      <label className="c-form__label" htmlFor="headerSelectCountry">
        Choose country
      </label>
      <div className="c-form__control">
        <div className="c-select-container  c-select-container--block">
          <select
            className="c-select"
            id="headerSelectCountry"
            defaultValue="us"
          >
            <optgroup label="Asia-Pacific">
              <option value="au">Australia</option>
              <option value="cn">China</option>
              <option value="hk">Hong Kong</option>
              <option value="nz">New Zealand</option>
              <option value="sg">Singapore</option>
            </optgroup>
            <optgroup label="North America">
              <option value="ca">Canada</option>
              <option value="us">United States</option>
            </optgroup>
            <optgroup label="Europe, the Middle East and Africa">
              <option value="at">Austria</option>
              <option value="be">Belgium</option>
              <option value="dk">Denmark</option>
              <option value="fi">Finland</option>
              <option value="fr">France</option>
              <option value="de">Germany</option>
              <option value="it">Italy</option>
              <option value="ie">Ireland</option>
              <option value="nl">Netherlands</option>
              <option value="no">Norway</option>
              <option value="es">Spain</option>
              <option value="se">Sweden</option>
              <option value="ch">Switzerland</option>
              <option value="gb">United Kingdom</option>
              <option value="ue">US Software Enrollments</option>
            </optgroup>
          </select>
        </div>
      </div>
    </div>
    <div className="c-form__element">
      <label className="c-form__label" htmlFor="headerSelectLanguage">
        Choose language
      </label>
      <div className="c-form__control">
        <div className="c-select-container  c-select-container--block">
          <select
            id="headerSelectLanguage"
            className="c-select"
            defaultValue="en"
          >
            <option value="de">Deutsch</option>
            <option value="en">English</option>
            <option value="es">Español</option>
            <option value="fr">Français</option>
            <option value="it">Italiano</option>
            <option value="nl">Nederlands</option>
            <option value="sv">Svenska</option>
          </select>
        </div>
      </div>
    </div>
    <Button color="primary" fullWidth>
      Go
    </Button>
  </form>

export default HeaderFlyoutLocaleForm;

HeaderFlyoutLocaleForm.propTypes = {
  country: PropTypes.string.isRequired,
};
